export const triggers = [
  {
    trigger: "Gluten",
    sources: [
      "bread",
      "pasta",
      "pastries",
      "crackers",
      "barley",
      "rye",
      "couscous",
      "sauces",
      "soups",
      "dressings",
    ],
    symptoms: [
      "bloating",
      "diarrhea",
      "constipation",
      "fatigue",
      "brain fog",
      "headaches",
      "joint pain",
      "depression",
    ],
    why: "Celiac disease triggers gut inflammation; non-celiac sensitivity causes immune reactions. Modern wheat processing increases difficulty digesting.",
  },
  {
    trigger: "Dairy",
    exclusions: [
      "peanut butter",
      "almond butter",
      "cashew butter",
      "seed butter",
      "nut butter",
      "soy milk",
      "almond milk",
      "oat milk",
      "rice milk",
      "hemp milk",
      "plant milk",
      "non-dairy milk",
      "nondairy milk",
      "coconut milk",
      "pea milk",
      "cashew milk",
      "macadamia milk",
      "flax milk",
      "tiger nut milk",
      "quinoa milk",
      "hazelnut milk",
      "pistachio milk",
      "walnut milk",
      "barley milk",
      "sunflower milk",
      "pea protein milk",
      "chia milk",
      "spelt milk",
      "chestnut milk",
      "banana milk",
      "avocado milk",
      "macadamia milk",
      "walnut milk",
    ],
    sources: [
      "milk",
      "cheese",
      "yogurt",
      "butter",
      "cream",
      "ice cream",
      "whey protein",
      "casein-based products",
    ],
    symptoms: [
      "bloating",
      "gas",
      "skin rashes",
      "fatigue",
      "brain fog",
      "joint pain",
      "sinus issues",
    ],
    why: "Lactose intolerance affects digestion; casein/whey sensitivities promote inflammation. Modern dairy practices may worsen symptoms.",
  },
  {
    trigger: "Soy",
    sources: [
      "tofu",
      "soy milk",
      "edamame",
      "tempeh",
      "miso",
      "soy sauce",
      "vegetarian meat substitutes",
    ],
    symptoms: [
      "bloating",
      "gas",
      "itchy rashes",
      "fatigue",
      "brain fog",
      "irregular menstrual cycles",
    ],
    why: "Soy contains goitrogens that impair thyroid function and phytoestrogens that disrupt hormones. GMOs and pesticides exacerbate inflammation.",
  },
  {
    trigger: "Alcohol",
    sources: [
      "beer",
      "wine",
      "liquor",
      "cocktails",
      "sweet wines",
      "hard ciders",
      "premixed drinks",
    ],
    symptoms: [
      "anxiety",
      "depression",
      "disrupted sleep",
      "fatigue",
      "brain fog",
      "bloating",
      "blood sugar fluctuations",
    ],
    why: "Alcohol disrupts neurotransmitters, impacts liver detox, and causes blood sugar spikes. Chronic consumption promotes inflammation.",
  },
  {
    trigger: "Caffeine",
    sources: [
      "coffee",
      "tea",
      "energy drinks",
      "sodas",
      "chocolate",
      "pre-workout supplements",
    ],
    symptoms: [
      "anxiety",
      "jitteriness",
      "irritability",
      "insomnia",
      "acid reflux",
      "stomach upset",
    ],
    why: "Caffeine overstimulates the nervous system, disrupts sleep, and increases stomach acid, causing mood and digestive issues.",
  },
  {
    trigger: "Refined Sugars & Processed Carbs",
    sources: [
      "candy",
      "pastries",
      "cookies",
      "cakes",
      "soda",
      "syrups",
      "granola bars with added sugars",
    ],
    symptoms: [
      "mood swings",
      "irritability",
      "fatigue",
      "brain fog",
      "weight gain",
      "cravings",
      "headaches",
    ],
    why: "Refined sugars cause blood sugar spikes and crashes, trigger inflammation, and disrupt hormonal balance, affecting mood and energy.",
  },
  {
    trigger: "Trans Fats",
    sources: [
      "margarine",
      "shortening",
      "processed snacks",
      "packaged baked goods",
      "fast food",
    ],
    symptoms: [
      "low mood",
      "irritability",
      "fatigue",
      "sluggishness",
      "joint pain",
      "high cholesterol",
    ],
    why: "Trans fats promote systemic inflammation, disrupt hormones like leptin, and impair cardiovascular health. Modern labels may obscure trans fat content.",
  },
  {
    trigger: "Food Additives",
    sources: [
      "msg",
      "sodium benzoate",
      "sulfites",
      "artificial colors",
      "flavors",
      "red 40",
      "blue 1",
      "yellow 5",
      "yellow 6",
    ],
    symptoms: [
      "headaches",
      "irritability",
      "hyperactivity",
      "mood swings",
      "brain fog",
      "allergic reactions",
    ],
    why: "MSG overstimulates neurons; preservatives trigger inflammation; petroleum-based dyes disrupt gut health and neurotransmitters.",
  },
  {
    trigger: "Seed Oils",
    sources: [
      "canola oil",
      "corn oil",
      "soybean oil",
      "sunflower oil",
      "salad dressings",
      "processed snacks",
    ],
    symptoms: [
      "joint pain",
      "muscle soreness",
      "mood instability",
      "irritability",
      "brain fog",
      "difficulty concentrating",
    ],
    why: "High omega-6 levels disrupt omega-3 balance, promoting inflammation and affecting mood and brain function.",
  },
  {
    trigger: "Artificial Sweeteners",
    sources: [
      "diet sodas",
      "sugar-free candies",
      "light yogurts",
      "sugar-free gum",
      "protein bars",
    ],
    symptoms: [
      "irritability",
      "anxiety",
      "depression",
      "headaches",
      "brain fog",
      "digestive discomfort",
    ],
    why: "Aspartame lowers serotonin; sucralose disrupts gut microbiota, impacting mood and cognition.",
  },
  {
    trigger: "Acidic Foods",
    sources: [
      "coffee",
      "tea",
      "soda",
      "citrus fruits",
      "vinegar",
      "ketchup",
      "processed tomato products",
    ],
    symptoms: [
      "heartburn",
      "acid reflux",
      "fatigue",
      "disrupted sleep",
      "low mood",
      "bloating",
    ],
    why: "Acidic foods weaken esophageal sphincter, cause reflux, and disrupt sleep and energy.",
  },
  {
    trigger: "Gums & Emulsifiers",
    sources: [
      "xanthan gum",
      "guar gum",
      "carrageenan",
      "gellan gum",
      "lecithin",
      "polysorbate 80",
      "mono- and diglycerides",
      "carboxymethylcellulose",
      "locust bean gum",
    ],
    symptoms: [
      "bloating",
      "gas",
      "diarrhea",
      "stomach cramps",
      "brain fog",
      "difficulty concentrating",
      "fatigue",
      "sluggishness",
      "low-grade inflammation",
    ],
    why: "Disrupt gut lining and microbiota, causing inflammation and symptoms like bloating, fatigue, and brain fog. Widely used in processed foods for texture and shelf life but may contribute to 'leaky gut'.",
  },
  {
    trigger: "High-Histamine Foods",
    sources: [
      "sauerkraut",
      "kimchi",
      "aged cheeses",
      "bacon",
      "sausage",
      "wine",
      "beer",
      "pickled foods",
    ],
    symptoms: [
      "anxiety",
      "mood swings",
      "headaches",
      "brain fog",
      "rashes",
      "bloating",
      "fatigue",
    ],
    why: "High-histamine foods overwhelm metabolism, causing inflammation, mood swings, and brain fog.",
  },
  {
    trigger: "Lectins and Nightshades",
    sources: [
      "beans",
      "lentils",
      "peanuts",
      "tomatoes",
      "potatoes",
      "eggplants",
      "bell peppers",
      "chili peppers",
    ],
    symptoms: [
      "bloating",
      "diarrhea",
      "joint pain",
      "muscle soreness",
      "brain fog",
      "fatigue",
      "skin irritation",
    ],
    why: "Lectins and alkaloids in nightshades irritate the gut, trigger inflammation, and disrupt digestion and mood.",
  },
];
